import { defineMessages } from '@jutro/locale';

export default defineMessages({
    
});